import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'plus', 'Plus', [["path",{"d":"M12 5l0 14"}],["path",{"d":"M5 12l14 0"}]]);